import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { concatMap, filter, first, map, switchMap, take } from 'rxjs/operators';
import { isMaintenance } from 'wflow-main-app/src/app/pages/maintenance/maintenance.util';
import { APP_ROUTES } from 'wflow-main-app/src/app/routing.const';
import { AuthService } from '../../auth/auth.service';
import { DowntimeAPIService } from '../api/api/downtime/downtime.service';

// TODO: rework this guard
@Injectable({
  providedIn: 'root',
})
export class ForbiddenGuard {
  readonly authSvc = inject(AuthService);
  readonly router = inject(Router);
  private readonly downtimeAPIService = inject(DowntimeAPIService);

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.#isAuthorized().pipe(
      concatMap((isAuthorize) =>
        isAuthorize ? of(true) : this.#redirect(state),
      ),
    );
  }

  public canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.#isAuthorized().pipe(
      concatMap((isAuthorize) =>
        isAuthorize ? of(true) : this.#redirect(state),
      ),
    );
  }

  #isAuthorized() {
    return this.authSvc.loading$.pipe(
      filter((v) => !v),
      take(1),
      map(() => this.authSvc.isAuthorize()),
    );
  }

  #redirect(state: RouterStateSnapshot) {
    return this.downtimeAPIService.getDowntimeInfo().pipe(
      take(1),
      map((downtimeInfo) =>
        isMaintenance(downtimeInfo)
          ? this.router.createUrlTree([APP_ROUTES.MAINTENANCE])
          : null,
      ),
      switchMap((urlTree) => {
        if (urlTree !== null) {
          return of(urlTree);
        }

        return this.authSvc.isAuthorize$.pipe(
          first(),
          map((isAuthorize) => {
            if (!isAuthorize && !this.router.url.includes('callback')) {
              return this.router.createUrlTree([APP_ROUTES.UNAUTHORIZED], {
                queryParams: {
                  redirectUrl: state.url,
                },
              });
            }

            return isAuthorize;
          }),
        );
      }),
    );
  }
}
